import { useQuery } from '@tanstack/react-query'

import { axios, ExtractFnReturnType, QueryConfig } from '@apps-common/lib'
import { ISearchCountModel } from '@apps-common/types/general'
import { IUnitTaskQueueSearchParamsModel } from '@apps-common/types/portal/unit-tasks'

export const QUERY_KEY_MANAGEMENT_SEARCH_UNIT_TASK_QUEUE_COUNT = (taskGroupId?: number, model?: IUnitTaskQueueSearchParamsModel) =>
  ['searchUnitTaskQueueCount', taskGroupId, model?.status, model?.startDate, model?.endDate, model?.take, model?.orderBy].filter(Boolean)

export const searchUnitTaskQueueCount = async (taskGroupId: number, model: IUnitTaskQueueSearchParamsModel): Promise<ISearchCountModel> =>
  axios.post('/management/UnitProgramTask/SearchTaskQueueCount', { taskGroupId, ...model }).then((res) => res.data?.data)

type QueryFnType = typeof searchUnitTaskQueueCount

type Props = {
  config?: QueryConfig<QueryFnType>
  taskGroupId: number
  model: IUnitTaskQueueSearchParamsModel
}

export const useManagementSearchUnitTaskQueueCount = ({ config, taskGroupId, model }: Props) =>
  useQuery<ExtractFnReturnType<QueryFnType>>({
    ...{ ...config, staleTime: 0, gcTime: 0 },
    queryKey: QUERY_KEY_MANAGEMENT_SEARCH_UNIT_TASK_QUEUE_COUNT(taskGroupId, model),
    queryFn: () => searchUnitTaskQueueCount(taskGroupId, model)
  })
